import { Box } from '@mui/material';

import { InfoDialog, Button } from '@occc-app/design-system';

export type ChangeSubmitterIdModalProps = {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  cpgName: string;
};

export const ChangeSubmitterIdModal = ({
  show,
  onCancel,
  onConfirm,
  cpgName,
}: ChangeSubmitterIdModalProps) => {
  return (
    <InfoDialog open={show} maxWidth='sm' hideCloseButton onClose={onCancel} fullWidth>
      <Box sx={{ p: 1 }}>
        <Box sx={{ mb: 2 }}>
          Attempting to change the {cpgName} Submitter ID will update it for all stores in this
          group.
        </Box>
        <Box>Please confirm this change is correct before proceeding.</Box>
        <Box display='flex' justifyContent='flex-end' gap={1} mt={3}>
          <Button variant='text' onClick={onCancel}>
            CANCEL
          </Button>
          <Button variant='contained' onClick={onConfirm}>
            I Understand
          </Button>
        </Box>
      </Box>
    </InfoDialog>
  );
};
